import React, { useState, useEffect } from "react";
import "./Navbar.scss";
import logo from "../../assets/images/whitelogo.png";
import blacklogo from "../../assets/images/blacklogo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [lightSection, setLightSection] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setScrolled(scrollPosition > 50);

      // Detect section when it enters 90% of screen height
      const sections = document.querySelectorAll(".section");
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.1 && rect.bottom > window.innerHeight * 0.1) {
          const isLight = section.classList.contains("light-section");
          setLightSection(isLight);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarClass = `navbar ${
    !scrolled
      ? "navbar-default-mode"
      : lightSection
      ? "navbar-light-mode"
      : "navbar-dark-mode"
  }`;

  return (
    <nav className={`${navbarClass} navbar-expand-lg fixed-top`}>
      <div className="container-fluid">
        <img
          src={!scrolled || lightSection ? blacklogo : logo}
          alt="Ettiksoft Logo"
          width="200"
        />
      </div>
    </nav>
  );
};

export default Navbar;
